import { getTokenFromCookies, url } from "../utils/configData";

const fetchUpdateUserData = async (id, object) => {
  const end = `/users/${id}/update`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  const body = JSON.stringify(object);
  try {
    const response = await fetch(url + end, {
      method: "PATCH",
      credentials: "include",
      headers: headers,
      body: body,
    });
    if (response.ok) {
      return object;
    } else if (response.status === 412) {
      return false;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }
};

const fetchChangesEmail = async (id, email, password) => {
  const end = `/users/${id}/update/email/send-code`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  const body = JSON.stringify({ new_email: email, password: password });
  try {
    const response = await fetch(url + end, {
      method: "POST",
      credentials: "include",
      headers: headers,
      body: body,
    });
    if (response.ok) {
      return { status: response.status, susscess: true };;
    } else {
      return { status: response.status, susscess: false };
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }
};
const fetchChangesPhone = async (id, phone, password) => {
  const end = `/users/${id}/update/phone/send-code`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  const body = JSON.stringify({ new_phone: phone, password: password });
  try {
    const response = await fetch(url + end, {
      method: "POST",
      credentials: "include",
      headers: headers,
      body: body,
    });
    if (response.ok) {
      return { status: response.status, susscess: true };
    } else {
      return { status: response.status, susscess: false };
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }

};

const fetchLocutorName = async (id) => {
  const end = `/users/${id}/name`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  try {
    const response = await fetch(url + end, {
      method: "GET",
      credentials: "include",
      headers: headers,
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return {
        fname: "CryptoHub",
        lname: null
      };
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }
};

const fetchSendCode = async (id, code) => {
  const end = `/users/${id}/update/email/change`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  const body = JSON.stringify({ code: code });
  try {
    const response = await fetch(url + end, {
      method: "PATCH",
      credentials: "include",
      headers: headers,
      body: body,
    });
    console.log(response.status);
    if (response.ok) {
      return { status: response.status, susscess: true };
    } else if (response.status === 409) {
      return { status: response.status, susscess: false };
    } else {
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }
};

const fetchSendCodePhone = async (id, code, newPhone) => {
  const end = `/users/${id}/update/phone/change`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  const body = JSON.stringify({ code: code, new_phone: newPhone });
  try {
    const response = await fetch(url + end, {
      method: "PATCH",
      credentials: "include",
      headers: headers,
      body: body,
    });
    console.log(response.status);
    if (response.ok) {
      return { status: response.status, susscess: true };
    } else if (response.status === 409) {
      return { status: response.status, susscess: false };
    } else {
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }
}



const mockFetchUser = async (id) => {
  const end = `/users/${id}`;
  const token = getTokenFromCookies();
  try {
    const response = await fetch(url + end, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }),
      }
    });

    // Перевірка, чи є відповідь об'єктом Response
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // Перевіряємо, чи є response об'єктом з методом json()
    if (typeof response.json !== 'function') {
      throw new TypeError('Response does not have a json method');
    }

    // Парсимо JSON з відповіді
    const data = await response.json();

    const userData = {
      id: id,
      fname: data.fname || "John",
      mname: data.mname || "Le",
      lname: data.lname || "Doe",
      age: data.age || 30,
      verif: data.verif || 0,
      sumsub: data.applicantID || "fdgf234523423432432",
      email: data.email || "test@test.test",
      phone: data.phone || "0000000000",
    };

    return userData;

  } catch (error) {
    console.error("Error fetching user data:", error.message || error);
    throw error;
  }
}




export {
  fetchUpdateUserData,
  fetchChangesEmail,
  fetchLocutorName,
  fetchSendCode,
  fetchChangesPhone,
  fetchSendCodePhone,
  mockFetchUser
};
